const {bind} = require('../lib/bind')

Stats = {
  host: "speakerdeck.com",

  record: function(type, data) {
    const image = new Image()
    image.src = `${this.beaconUrl()}?${this.toQueryString(type, data)}`;
  },

  toQueryString: function(type, data) {
    const queryStringParts = [
      'version=one',
      `type=${type}`,
      `timestamp=${Stats.timestamp()}`,
    ];

    const encodedData = Object.entries(data).map(([key, value]) => {
      return [this.encode(key), this.encode(value)]
    });

    encodedData.forEach(([key, value]) => {
      queryStringParts.push(`data[${key}]=${value}`);
    });

    return queryStringParts.join('&');
  },

  beaconUrl: function() {
    return `//${this.host}/beacon.gif`;
  },

  timestamp: function() {
    return new Date().getTime();
  },

  encode: function(string) {
    return string ? window.encodeURIComponent(string) : "";
  }
};

Stats.Page = {
  data: function() {
    const pageData = {
      page: Stats.Page.url(),
      referrer: Stats.Page.referrer(),
    }

    return Object.assign({}, pageData, this.metaTagData());
  },

  metaTagData: function() {
    const queryResult = document.querySelectorAll('meta[name|=stats]');
    const metaTags = Array.prototype.slice.call(queryResult);

    return metaTags.reduce(function(data, tag) {
      const key = tag.name.replace(/^stats-/, '');
      const value = tag.content;
      data[key] = value;
      return data;
    }, {});
  },

  url: function() {
    try {
      return document.location.href;
    } catch(error) {
      return undefined;
    }
  },

  referrer: function() {
    try {
      return window.top.document.referrer;
    } catch(error1) {
      try {
        return window.parent.document.referrer;
      } catch(error2) {
        return  undefined;
      }
    }
    return document.referrer;
  }
}

bind(document, 'DOMContentLoaded', () => {
  Stats.record('page_view', Stats.Page.data());
});
